module.exports = __webpack_public_path__ + "img/gpt-task.ecacf2c6.svg";